/* Hook to access the kiwi reward context from any component. */

import { useContext } from "react";
import { KiwiRewardContext } from "@/contexts/kiwiRewardContextValue";

export function useKiwiReward() {
  const ctx = useContext(KiwiRewardContext);
  if (!ctx) {
    throw new Error("useKiwiReward must be used within a KiwiRewardProvider");
  }
  return ctx;
}
